module.exports = __webpack_public_path__ + "media/customizations/brighton/back-427457899821fdc7d54ab3798fc50bf0.jpg";